import { Box, Text } from "@mantine/core";
import CheckCircleRounded from "@mui/icons-material/CheckCircleRounded";
import classes from "./feature-tab.module.css";

interface FeatureTabProps {
  title: string;
  description: string;
  isActive: boolean;
  onClick: () => void;
  lightBg?: boolean;
}

export default function FeatureTab({
  title,
  description,
  isActive,
  onClick,
  lightBg = false,
}: FeatureTabProps) {
  return (
    <Box
      className={classes.tab}
      onClick={onClick}
      data-active={isActive ? "true" : undefined}
      data-light-bg={lightBg ? "true" : undefined}
    >
      <div className={classes.header}>
        <CheckCircleRounded className={classes.icon} />
        <Text className={classes.title}>{title}</Text>
      </div>
      <Text className={classes.description}>{description}</Text>
    </Box>
  );
}
